export const INVITATION_API_GET_INVITES_REQUEST = 'INVITATION_API_GET_INVITES_REQUEST';
export const INVITATION_API_GET_INVITES_SUCCESS = 'INVITATION_API_GET_INVITES_SUCCESS';
export const INVITATION_API_GET_INVITES_FAILURE = 'INVITATION_API_GET_INVITES_FAILURE';

export const INVITATION_API_UPDATE_INVITE_REQUEST = 'INVITATION_API_UPDATE_INVITE_REQUEST';
export const INVITATION_API_UPDATE_INVITE_SUCCESS = 'INVITATION_API_UPDATE_INVITE_SUCCESS';
export const INVITATION_API_UPDATE_INVITE_FAILURE = 'INVITATION_API_UPDATE_INVITE_FAILURE';